import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";

import { Box, Stack, Typography } from "@mui/material";

import PayPeriodModal from "../modals/PayPeriodModal";

import usePayroll from "../../hooks/usePayroll";
import EditorToolbar from "../editors/EditorToolbar";
import SimpleTable from "../elements/Table";

const PayPeriods = () => {
  const navigate = useNavigate();

  const { payPeriods, fiscalYears, refreshPayPeriods } = usePayroll();

  const [payPeriodId, setPayPeriodId] = useState(null);
  const [openModal, setOpenModal] = useState();

  const handleAdd = () => {
    setPayPeriodId(null);
    setOpenModal(true);
  };

  const handleEdit = (id) => {
    setPayPeriodId(id);
    setOpenModal(true);
  };

  const handleCloseModal = async () => {
    setOpenModal(false);
    setPayPeriodId(null);
    await refreshPayPeriods();
  };

  const formatDate = (date) => {
    return format(date, "EEE, MMM dd, yyyy");
  };

  const formatBoolean = (value) => {
    return value ? "Yes" : "No";
  };

  const handleProcessing = (id) => {
    navigate("/payperiodprocessing", {
      state: { payPeriodId: id, backDestination: "/payroll" },
    });
  };

  return (
    <>
      <Box>
        <EditorToolbar onAdd={handleAdd} />
        {Array.isArray(payPeriods) && payPeriods.length > 0 ? (
          <SimpleTable
            config={{
              columns: [
                {
                  name: "name",
                  label: "Name",
                  sx: { width: "200px" },
                },
                {
                  name: "startDate",
                  label: "Start",
                  sx: { width: "100px" },
                  format: formatDate,
                },
                {
                  name: "endDate",
                  label: "End",
                  sx: { width: "100px" },
                  format: formatDate,
                },
                {
                  name: "processDate",
                  label: "Process",
                  sx: { width: "100px" },
                  format: formatDate,
                },
                {
                  name: "status",
                  label: "Status",
                  sx: { width: "100px" },
                  format: (value) =>
                    value?.charAt(0).toUpperCase() + value?.slice(1),
                },
              ],
              actions: [
                {
                  name: "edit",
                  label: "Edit",
                  iconName: "EditSquare",
                  onClick: handleEdit,
                },
                {
                  name: "process",
                  label: "Process",
                  iconName: "Settings",
                  onClick: handleProcessing,
                },
              ],
            }}
            data={payPeriods}
          />
        ) : (
          <Typography>No Pay Periods Available</Typography>
        )}
      </Box>

      {openModal && (
        <PayPeriodModal
          payPeriodId={payPeriodId}
          open={openModal}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
};

export default PayPeriods;
